import * as React from 'react'

const EntityHeader = (props: { children: any }) => {
  return <div className='flex p2 items-center'>{props.children}</div>
}

export default EntityHeader



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityHeader.tsx